var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('the-home-header'),_c('div',{staticClass:"animationFix"},[_vm._t("default")],2),_c('the-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }